"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../../../elements/course/Scrollbar/constants");
const theme_1 = require("../../theme");
const genStyle_1 = require("../genStyle");
const styleSchema = {
    scrollbar: {
        visibility: (0, genStyle_1.genStyle)({ value: 'scroll' }),
        width: (0, genStyle_1.genStyle)({ value: 6 }),
        color: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.inactiveColor }),
        hoverColor: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.hoverColor }),
        borderRadius: (0, genStyle_1.genStyle)({ value: 4 }),
        borderStyle: (0, genStyle_1.genStyle)({ value: 'none' }),
        borderColor: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.borderColor }),
        borderWidth: (0, genStyle_1.genStyle)({ value: 1 }),
    },
    effects: {
        boxShadow: (0, genStyle_1.genStyle)({ theme: theme_1.KEYS.boxShadow }),
    },
};
exports.default = { [constants_1.TYPE]: { style: styleSchema, font: {}, feedback: {} } };
